import { useChargeDataSearchVM } from "presentation/hook/ChargeDataEnquiry/useChargeDataSearchVM";
import { useChargeDataSearchTracked } from "presentation/store/ChargeDataEnquiry/ChargeDataSearchProvider";
import { useState } from "react";
import { DialogModal, HPHButton, IconButton, InputField } from "veronica-ui-component/dist/component/core";

export interface IPreferenceModal {
    visible: boolean;
}

export const SaveNewPreferenceModal: React.FC<IPreferenceModal> = (props: IPreferenceModal) => {
    const { visible } = props;
    const [preferenceName, setPreferenceName] = useState('');
    const [chargeDataSearchState] = useChargeDataSearchTracked();
    const chargeDataSearchVM = useChargeDataSearchVM();
    const userEmail = chargeDataSearchState.userEmail;
    const searchCriteria = chargeDataSearchState.searchCriteria;
    const enabledSearchCriteria = chargeDataSearchState.enabledSearchCriteria;

    const onConfirmClicked = () => {
        chargeDataSearchVM.showLoading();
        chargeDataSearchVM.saveNewSearchPreference(userEmail, searchCriteria, enabledSearchCriteria, preferenceName).then(data => {
            chargeDataSearchVM.loadAllSearchPreference(userEmail).then(data => {
                chargeDataSearchVM.hideLoading();
            }).catch(error => {
                chargeDataSearchVM.hideLoading();
            })
        }).catch(error => {
            chargeDataSearchVM.hideLoading();
        })
    }

    return <DialogModal
        appendTo='self'
        showButton={false}
        visible={visible}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">NEW PREFERENCE</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={chargeDataSearchVM.closeConfirmModal} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className="im-charge-data-search-confirm-modal-content">
                <InputField maxLength={999} label="Name" type="text" value={preferenceName} onChange={(e) => setPreferenceName(e.target.value)} allowedSpecialChars={'all'} />
            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                <HPHButton label={'Confirm'} size={'Small'} theme={'Primary'} onClick={onConfirmClicked} />
            </div>
        }
    />;
};
